(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    function isAtTop(elem) {
      const rect = elem.getBoundingClientRect();
      return rect.top <= 0; // element touches top
    }
    function changeStyling(){
      const el = document.querySelector(".add-to-cart-bar-container");
      // const logoEl = document.querySelector("#product_how_to_use_section")
      const buyButtonsEl = document.querySelector(".product-details product-form-component")
      if(window.innerWidth <= 767){
        if (buyButtonsEl && isAtTop(buyButtonsEl)) {
          jQuery('.add-to-cart-bar-container').fadeIn(500)
        }else{
          jQuery('.add-to-cart-bar-container').fadeOut(500)
        }
        // el.style.display = "";
        el.style.position = "";
        el.style.top = "";
        el.style.zIndex = "";
      }else{
        // if (logoEl && isAtTop(logoEl)) {
        if (buyButtonsEl && isAtTop(buyButtonsEl)) {
          jQuery('.add-to-cart-bar-container').fadeIn(500)
          if (el) {
            el.style.position = "fixed";
            el.style.top = "75px";
            el.style.zIndex = "9999";
          }
        }else{
          jQuery(".add-to-cart-bar-container").fadeOut(500)
        }
      }
    }
    changeStyling()
    window.addEventListener("scroll", () => {
      changeStyling()
    });
    window.addEventListener('resize', () => {
      changeStyling()
    });
  })

  } catch(e) { console.error(e); }
})();
})();
